export const BASE_URL =
  'https://as-quizai-uks-prod-g3c6h9ftgeh2bben.uksouth-01.azurewebsites.net';
export const BUTTON_SECTION_HEIGHT_PERCENTEGES = 30;

export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const LOADING_SLIDE_TIMEOUT_MS = 1500;
export const LOADER_SLIDES_TEXT = [
  'Analyzing...',
  'Preparing...',
  'Finalyzing...',
];

export const ERROR_MESSAGE = 'Something went wrong with fetching data';


interface Size {
  xs: string
  sm: string
  md: string
  lg: string
  xl: string
  xxl: string
}

const size: Size = {
  xs: '320px', // for small screen mobile
  sm: '640px', // for mobile screen
  md: '768px', // for tablets
  lg: '1024px', // for laptops
  xl: '1280px', // for desktop / monitors
  xxl: '1440px', // for big screens
}

export const device = {
  xs: `(max-width: ${size.xs})`,
  sm: `(max-width: ${size.sm})`,
  md: `(max-width: ${size.md})`,
  lg: `(max-width: ${size.lg})`,
  xl: `(max-width: ${size.xl})`,
  xxl: `(max-width: ${size.xxl})`,
}